import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
    moduleId: module.id,
    selector: 'menu-compositions',
    templateUrl: 'menu-compositions.component.html',
    styleUrls: ['menu-compositions.component.scss']
})
export class MenuCompositionsComponent {
    compositions:any[]=[];
    label="";

    constructor(
        public bsModalRef: BsModalRef,
    ) {
    }

    closemodel(){
        this.bsModalRef.hide();
    }
}
